import { render, staticRenderFns } from "./ResearchUploadAreaNew.vue?vue&type=template&id=d7994cd2&"
import script from "./ResearchUploadAreaNew.vue?vue&type=script&lang=js&"
export * from "./ResearchUploadAreaNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports